import { gql } from '@apollo/client';
import { IModel } from '../../../../store/AddMachine';

import { TLaunchDarklySet } from '../../../../store/LaunchDarkly';

import { TQueryResponse } from '../../../types';
import { client } from '../../graphql';
import { IRawDeviceModel, mapToModel } from '../utils/modelMapping';

export const getDeviceModelsComplex = async (
  launchDarkly: TLaunchDarklySet,
  brandId: string,
  country?: string,
  categoryId?: string,
  subCategoryId?: string,
): Promise<IModel[]> => {
  const filterParts = [`brandId: "${brandId}"`, `countries: ${JSON.stringify(country ? [country] : [])}`];

  if (categoryId) {
    filterParts.push(`categoryId: "${categoryId}"`);
  }

  if (subCategoryId) {
    filterParts.push(`subCategoryId: "${subCategoryId}"`);
  }

  const { data } = await client(launchDarkly).query<TQueryResponse<'deviceModelsComplex', IRawDeviceModel[]>>({
    query: gql`
      query {
        deviceModelsComplex(filter: { ${filterParts.join(', ')} }) {
          id
          modelSeries {
            id
            brand {
              name
            }
            subCategory {
              id
              defaultDisplayName
              key
            }
            name
            deviceType
          }
          name
        }
      }
    `,
  });

  return data.deviceModelsComplex.map(mapToModel);
};
